import { REQUEST_AUTEURLIVRES, FETCH_AUTEURLIVRES_FAILURE, FETCH_AUTEURLIVRES_SUCCESS } from '../actions/auteur.js'
import { REQUEST_BIOBIBLIO, FETCH_BIOBIBLIO_FAILURE, FETCH_BIOBIBLIO_SUCCESS } from '../actions/auteur.js'
import { REQUEST_AUTEURLIENS, FETCH_AUTEURLIENS_FAILURE, FETCH_AUTEURLIENS_SUCCESS } from '../actions/auteur.js'
import { SAVE_BIBLIO_REQUEST, SAVE_BIBLIO_FAILURE, SAVE_BIBLIO_SUCCESS } from '../actions/auteur.js'
import { SAVE_BIO_REQUEST, SAVE_BIO_FAILURE, SAVE_BIO_SUCCESS } from '../actions/auteur.js'
import { SAVE_AUTEURLIEN_REQUEST, SAVE_AUTEURLIEN_FAILURE, SAVE_AUTEURLIEN_SUCCESS,
    HIDE_AUTEURLIEN_REQUEST, HIDE_AUTEURLIEN_FAILURE, HIDE_AUTEURLIEN_SUCCESS,
    SAVE_DATES_REQUEST, SAVE_DATES_SUCCESS, SAVE_DATES_FAILURE } from '../actions/auteur.js'

const AUTEUR_INITIAL_STATE = {
    'aid' : (typeof window !== 'undefined') ? window.aid : null,
    'loading' : false,
    'lastRefreshed' : null,
    'error' : null,
    'data' : null,
    'livres' : [],
    'processing' : false,
    'bio': null,
    'biblio' : null,
    'liens' : null
}

const auteur_reducer = function(state = AUTEUR_INITIAL_STATE ,action ){
    switch (action.type){
        case REQUEST_AUTEURLIVRES: 
            return Object.assign({},state,{'loading': true});
        case FETCH_AUTEURLIVRES_SUCCESS:
            return Object.assign({}, state, {'loading': false, 
                'lastRefreshed' : action.payload.lastRefreshed,
                'livres' : action.payload.livres});
        case FETCH_AUTEURLIVRES_FAILURE:
            return Object.assign({},state,{'loading': false, 'error': action.payload});
        case REQUEST_BIOBIBLIO:
            return Object.assign({}, state, {'loading' : true});
        case FETCH_BIOBIBLIO_SUCCESS:
            return Object.assign({}, state, {'loading' : false,
                    'bio' : {'html':action.payload.bio,
                            'uid' : action.payload.bio_uid,
                            'createdby' : action.payload.bio_createdby,
                            'closed' : action.payload.bio_closed,
                            'lastupd' : action.payload.bio_lastupd,
                            'lastupdby' : action.payload.bio_lastupdby,
                            'hidden' : action.payload.bio_hidden
                            },
                    'biblio' : {'html':action.payload.biblio,
                            'uid' : action.payload.bioblio_uid,
                            'createdby' : action.payload.biblio_createdby,
                            'closed' : action.payload.biblio_closed,
                            'lastupd' : action.payload.biblio_lastupd,
                            'lastupdby' : action.payload.biblio_lastupdby,
                            'hidden' : action.payload.biblio_hidden
                            }
                });
        case FETCH_BIOBIBLIO_FAILURE:
            return Object.assign({}, state, {'loading' : false,'error' : action.payload});
        case SAVE_BIBLIO_REQUEST:
            return Object.assign({},state,{'processing' : true});
        case SAVE_BIBLIO_FAILURE:
            return Object.assign({},state,{'processing' : false, 'error' : action.payload});
        case SAVE_BIBLIO_SUCCESS:
            return Object.assign({},state,
                {'processing' : false, 
                 'error' : null,
                 'biblio' : { 'html' : action.payload.biblio,
                              'uid' : action.payload.bioblio_uid,
                              'closed' : action.payload.biblio_closed,
                              'createdby' : action.payload.biblio_createdby,
                              'lastupd' : action.payload.biblio_lastupd,
                              'lastupdby' : action.payload.biblio_lastupdby,
                              'hidden' : action.payload.biblio_hidden
                            }
                });
        case SAVE_BIO_REQUEST:
            return Object.assign({},state,{'processing' : true});
        case SAVE_BIO_FAILURE:
            return Object.assign({},state,{'processing' : false, 'error' : action.payload});
        case SAVE_BIO_SUCCESS:
            return Object.assign({},state,
                {'processing' : false, 
                 'error' : null,
                 'bio' : { 'html' : action.payload.bio,
                           'uid' : action.payload.bio_uid,
                           'createdby' : action.payload.bio_createdby,
                           'closed' : action.payload.bio_closed,
                           'lastupd' : action.payload.bio_lastupd,
                           'lastupdby' : action.payload.bio_lastupdby,
                           'hidden' : action.payload.bio_hidden
                            }
                });
        case REQUEST_AUTEURLIENS:
            return Object.assign({}, state, {'loading' : true});
        case FETCH_AUTEURLIENS_SUCCESS:
            return Object.assign({}, state, {'loading': false, 'liens': action.payload, 'error': null});
        case FETCH_AUTEURLIENS_FAILURE:
            return Object.assign({}, state, {'loading': false, 'error': action.payload});
        case SAVE_AUTEURLIEN_REQUEST:
            return Object.assign({},state,{'processing': true});
        case SAVE_AUTEURLIEN_SUCCESS:
            let liens = [];
            let found = false;
            state.liens.map((el,idx)=>{
                if (el.id == action.payload.id){
                    liens.push(action.payload);
                    found = true;
                } else {
                    liens.push(el);
                }
            });
            if (! found){
                liens.push(action.payload);
            }
            return Object.assign({}, state,{'processing': false, 'liens': liens, 'error': null});
        case SAVE_AUTEURLIEN_FAILURE:
            return Object.assign({},state,{'processing': false,'error':action.payload});
        case HIDE_AUTEURLIEN_REQUEST:
            return Object.assign({},state,{'processing': true});
        case HIDE_AUTEURLIEN_SUCCESS:
            liens = state.liens.filter((el)=>{
                return el.id !== action.payload;
            });
            return Object.assign({}, state,{'processing': false, 'liens': liens, 'error': null});
        case HIDE_AUTEURLIEN_FAILURE:
            return Object.assign({},state,{'processing': false,'error':action.payload});            
        case SAVE_DATES_REQUEST:
            return Object.assign({},state,{'loading' : true});
        case SAVE_DATES_SUCCESS:
            return Object.assign({},state,{'date1' : action.payload.date1, 'date2' : action.payload.date2, 'loading' : false, 'error' : null});
        case SAVE_DATES_FAILURE:
            return Object.assign({},state,{'error' : action.payload, 'loading' : false});

        default:
            return state;
    }
}

export default auteur_reducer


// WEBPACK FOOTER //
// ./auteur/reducers/auteur.js